import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-vip-crown-line text-white text-lg"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-background-50">
                永利皇宫
              </span>
            </div>
            <p className="text-background-300/80 text-sm leading-relaxed">
              澳门顶级综合度假胜地，汇聚五星级酒店、精致餐饮、高端娱乐与购物体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-background-50 text-sm font-semibold mb-4">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/category/hotel" className="text-background-300/80 hover:text-background-100 text-sm transition-colors">酒店预订</Link>
              <Link to="/category/dining" className="text-background-300/80 hover:text-background-100 text-sm transition-colors">餐厅推荐</Link>
              <Link to="/category/entertainment" className="text-background-300/80 hover:text-background-100 text-sm transition-colors">娱乐体验</Link>
              <Link to="/category/shopping" className="text-background-300/80 hover:text-background-100 text-sm transition-colors">购物指南</Link>
              <Link to="/category/travel" className="text-background-300/80 hover:text-background-100 text-sm transition-colors">旅游攻略</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-background-50 text-sm font-semibold mb-4">热门文章</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/article/wynn-palace-suite-booking-guide" className="text-background-300/80 hover:text-background-100 text-sm transition-colors">套房预订全攻略</Link>
              <Link to="/article/wynn-palace-michelin-restaurants" className="text-background-300/80 hover:text-background-100 text-sm transition-colors">米其林餐厅全收录</Link>
              <Link to="/article/wynn-palace-performance-lake-show" className="text-background-300/80 hover:text-background-100 text-sm transition-colors">表演湖音乐喷泉</Link>
              <Link to="/article/wynn-palace-luxury-shopping" className="text-background-300/80 hover:text-background-100 text-sm transition-colors">名店街购物指南</Link>
              <Link to="/article/macau-three-day-itinerary" className="text-background-300/80 hover:text-background-100 text-sm transition-colors">澳门三天深度游</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-background-50 text-sm font-semibold mb-4">联系我们</h4>
            <div className="flex flex-col gap-3 text-background-300/80 text-sm">
              <div className="flex items-start gap-2">
                <i className="ri-map-pin-line text-base mt-0.5 shrink-0"></i>
                <span>澳门路氹体育馆大马路</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-phone-line text-base shrink-0"></i>
                <span>+853 8889 8889</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-mail-line text-base shrink-0"></i>
                <span>info@wynnpalace.com</span>
              </div>
              <Link
                to="/about"
                className="mt-2 inline-flex items-center gap-1.5 text-primary-400 hover:text-primary-300 transition-colors text-sm font-medium"
              >
                了解更多 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-foreground-800/40 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-background-400/60 text-xs">
            &copy; 2026 永利皇宫体验指南. 本网站为资讯分享平台，非永利皇宫官方网站.
          </p>
          <div className="flex items-center gap-4 text-background-400/60 text-xs">
            <a href="/about" className="hover:text-background-200 transition-colors">隐私政策</a>
            <a href="/about" className="hover:text-background-200 transition-colors">使用条款</a>
            <a href="/about" className="hover:text-background-200 transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}